import React from "react";
import { Button, Modal } from "react-bootstrap";
import { EventResponse } from "../services/api.response.service";
import { RouteEndpoints } from "../services/route.service";

interface props {
  details: EventResponse;
  setShowEventDetails: (event: undefined | EventResponse) => void;
}

const EventDetailsModal = ({ details, setShowEventDetails }: props) => {
  return (
    <>
      <Modal
        size="lg"
        show={!!details}
        onHide={() => setShowEventDetails(null!)}
        centered
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column gap-4">
            <div>
              <img
                src={details?.resource_url}
                alt={details?.title}
                className="w-100"
                style={{
                  // height: "192px",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />{" "}
              <div
                className="w-100 p-3"
                style={{ height: "149px", backgroundColor: "#F2F2F2" }}
              >
                <div className="row col-6">
                  <h3
                    className="pb-3"
                    style={{ fontSize: "14px", fontWeight: 600 }}
                  >
                    {details?.title}{" "}
                  </h3>

                  <div className="col-6 pb-2">
                    {" "}
                    <p
                      className="d-flex align-items-center gap-2 m-0"
                      style={{ fontSize: "10px" }}
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.0833 2.33398H2.91667C2.27233 2.33398 1.75 2.85632 1.75 3.50065V11.6673C1.75 12.3116 2.27233 12.834 2.91667 12.834H11.0833C11.7277 12.834 12.25 12.3116 12.25 11.6673V3.50065C12.25 2.85632 11.7277 2.33398 11.0833 2.33398Z"
                          stroke="#9E9E9E"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1.75 5.83398H12.25"
                          stroke="#9E9E9E"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M9.33337 1.16602V3.49935"
                          stroke="#9E9E9E"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M4.66663 1.16602V3.49935"
                          stroke="#9E9E9E"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      {/*Thurs, 17th Nov 2022{" "}*/}
                      {details?.date}
                    </p>
                  </div>
                  <div className="col-6 pb-2">
                    {" "}
                    <p
                      className="d-flex align-items-center gap-2 m-0"
                      style={{ fontSize: "10px" }}
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.99996 11.0827C9.25512 11.0827 11.0833 9.25451 11.0833 6.99935C11.0833 4.74419 9.25512 2.91602 6.99996 2.91602C4.7448 2.91602 2.91663 4.74419 2.91663 6.99935C2.91663 9.25451 4.7448 11.0827 6.99996 11.0827Z"
                          stroke="#9E9E9E"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7 5.25V7L7.875 7.875"
                          stroke="#9E9E9E"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M9.63078 10.1215L9.42662 12.3557C9.40033 12.6465 9.26591 12.917 9.0499 13.1135C8.83389 13.3101 8.55201 13.4185 8.25995 13.4173H5.73411C5.44206 13.4185 5.16018 13.3101 4.94417 13.1135C4.72816 12.917 4.59373 12.6465 4.56745 12.3557L4.36328 10.1215M4.36911 3.87983L4.57328 1.64566C4.59948 1.35579 4.73307 1.08618 4.94785 0.88975C5.16262 0.693323 5.44306 0.584268 5.73411 0.583994H8.27162C8.56367 0.582809 8.84555 0.69121 9.06156 0.887778C9.27757 1.08435 9.412 1.35479 9.43828 1.64566L9.64245 3.87983"
                          stroke="#9E9E9E"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      {/*4:00 PM - 5:00 PM GMT{" "}*/}
                      {details?.time}
                    </p>
                  </div>
                  <div className="col-6 pb-2">
                    {" "}
                    <p
                      className="d-flex align-items-center gap-2 m-0"
                      style={{ fontSize: "10px" }}
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.41667 6.94237V9.91737C6.41667 10.0721 6.47812 10.2205 6.58752 10.3299C6.69692 10.4392 6.84529 10.5007 7 10.5007C7.15471 10.5007 7.30308 10.4392 7.41248 10.3299C7.52187 10.2205 7.58333 10.0721 7.58333 9.91737V6.94237C8.29152 6.79781 8.92081 6.39545 9.3492 5.81328C9.77758 5.23111 9.97454 4.51062 9.9019 3.79148C9.82925 3.07235 9.49217 2.40581 8.95601 1.92108C8.41984 1.43635 7.72279 1.16797 7 1.16797C6.2772 1.16797 5.58016 1.43635 5.04399 1.92108C4.50783 2.40581 4.17075 3.07235 4.0981 3.79148C4.02546 4.51062 4.22242 5.23111 4.6508 5.81328C5.07919 6.39545 5.70848 6.79781 6.41667 6.94237ZM7 2.33404C7.34612 2.33404 7.68446 2.43668 7.97225 2.62897C8.26003 2.82126 8.48434 3.09457 8.61679 3.41434C8.74924 3.73411 8.7839 4.08598 8.71637 4.42545C8.64885 4.76491 8.48218 5.07674 8.23744 5.32148C7.99269 5.56622 7.68087 5.73289 7.34141 5.80041C7.00194 5.86794 6.65007 5.83328 6.3303 5.70083C6.01053 5.56838 5.73722 5.34407 5.54493 5.05629C5.35264 4.7685 5.25 4.43016 5.25 4.08404C5.25 3.61991 5.43437 3.17479 5.76256 2.8466C6.09075 2.51841 6.53587 2.33404 7 2.33404ZM9.45583 8.41237C9.37923 8.39629 9.30021 8.39545 9.22328 8.4099C9.14635 8.42435 9.07302 8.45381 9.00747 8.49661C8.94193 8.5394 8.88546 8.59468 8.84128 8.6593C8.7971 8.72392 8.76609 8.7966 8.75 8.87321C8.73391 8.94981 8.73307 9.02883 8.74752 9.10576C8.76198 9.18269 8.79144 9.25602 8.83423 9.32157C8.87703 9.38711 8.93231 9.44358 8.99693 9.48776C9.06154 9.53193 9.13423 9.56295 9.21083 9.57904C10.535 9.84154 11.0833 10.314 11.0833 10.5007C11.0833 10.839 9.65417 11.6674 7 11.6674C4.34583 11.6674 2.91667 10.839 2.91667 10.5007C2.91667 10.314 3.465 9.84154 4.78917 9.55571C4.86577 9.53962 4.93846 9.5086 5.00307 9.46442C5.06769 9.42025 5.12297 9.36377 5.16577 9.29823C5.20856 9.23269 5.23802 9.15936 5.25247 9.08243C5.26693 9.0055 5.26609 8.92648 5.25 8.84987C5.23391 8.77327 5.2029 8.70058 5.15872 8.63597C5.11454 8.57135 5.05807 8.51607 4.99253 8.47327C4.92698 8.43048 4.85365 8.40102 4.77672 8.38656C4.69979 8.37211 4.62077 8.37295 4.54417 8.38904C2.77083 8.79737 1.75 9.56154 1.75 10.5007C1.75 12.0349 4.3925 12.834 7 12.834C9.6075 12.834 12.25 12.0349 12.25 10.5007C12.25 9.56154 11.2292 8.79737 9.45583 8.41237Z"
                          fill="#9E9E9E"
                        />
                      </svg>
                      {/*Online{" "}*/}
                      {details?.venue}
                    </p>
                  </div>
                </div>
              </div>{" "}
            </div>

            <div>
              <small style={{ color: "#9E9E9E" }}>Description</small>
              <p>{details?.details}</p>
            </div>
            <div className="d-flex justify-content-between gap-5">
              <Button variant="primary" className="w-100">
                Add to calendar{" "}
              </Button>
              <Button
                variant="outline-primary"
                className="w-100"
                onClick={() =>
                  navigator.clipboard.writeText(
                    `${window.location.host}${RouteEndpoints?.VIEW_EVENTS(
                      `${details?.id}`
                    )}`
                  )
                }
              >
                Share{" "}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EventDetailsModal;
